// symbolName — 심볼 → 표시 이름 해석기 (2026-07-26)
//
// 배경: 체결 route에 심볼 화이트리스트가 없어 유니버스(SIM_SYMBOLS 75종) 밖 종목도 매수된다.
//   그런데 홈·실패박물관·종목비교의 이름 조회는 SIM_SYMBOLS만 봤다 → QQQ를 보유하면
//   이름 대신 티커가 그대로 노출됐다(B-2).
// 해법: 로컬 목록 → 로컬 캐시 순으로 해석하고, 서버 검색으로 이름을 한 번이라도 만나면 캐시에 적재한다.
//   (localStorage를 쓰므로 domain/core가 아니라 lib에 둔다 — core는 결정론 규칙)
import { SIM_SYMBOLS } from '@core/sim/market/simSymbols';

const KEY = 'sotda_symbol_names';
const MAX = 200; // 무한 성장 방지 — 넘으면 통째로 비운다(이름은 언제든 재취득 가능한 캐시)

let cache: Record<string, string> | null = null;

function read(): Record<string, string> {
  if (cache) return cache;
  try {
    const raw = localStorage.getItem(KEY);
    cache = raw ? (JSON.parse(raw) as Record<string, string>) : {};
  } catch { cache = {}; }
  return cache;
}

/** 서버 검색 등에서 만난 이름을 기억한다(이미 로컬 목록에 있으면 저장하지 않는다). */
export function rememberSymbolName(symbol?: string, name?: string) {
  if (!symbol || !name || symbol === name) return;
  if (SIM_SYMBOLS.some((s) => s.symbol === symbol)) return;
  const c = read();
  if (c[symbol] === name) return;
  const next = Object.keys(c).length >= MAX ? {} : c;
  next[symbol] = name;
  cache = next;
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* 저장 실패는 무시 — 표시만 티커로 */ }
}

/** 심볼의 표시 이름. 로컬 목록 → 캐시 → (없으면) 심볼 그대로. */
export function resolveSymbolName(symbol?: string): string {
  if (!symbol) return '';
  const meta = SIM_SYMBOLS.find((s) => s.symbol === symbol);
  if (meta) return meta.name;
  return read()[symbol] || symbol;
}
